module.exports = __webpack_public_path__ + "img/enter.3426c57d.svg";